import { DmpCommonsComponent } from './dmp/components/shared/dmp-commons/dmp-commons.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './dmp/components/home/home.component';
import { SignInComponent } from './dmp/components/sign-in/sign-in.component';
import { SignUpComponent } from './dmp/components/sign-up/sign-up.component';
import { EnterpriseComponent } from './dmp/components/enterprise/enterprise.component';
import { DeviceComponent } from './dmp/components/device/device.component';
import { MobileAppComponent } from './dmp/components/mobile-app/mobile-app.component';
import { TesteComponent } from './dmp/components/teste/teste.component';
import { MobileAppInstallComponent } from './dmp/components/mobile-app-install/mobile-app-install.component';
import { MobileAppInstallManagedGooglePlayComponent } from './dmp/components/mobile-app-install-managed-google-play/mobile-app-install-managed-google-play.component';
import { AppLayoutComponent } from "./layout/app.layout.component";
import { CommonModule } from '@angular/common'; // Import CommonModule

const baseRoutes: Routes = [
  {
    path: 'home', component: AppLayoutComponent,
    children: [
        { path: 'dashboard', loadChildren: () => import('./dmp/components/dashboard/dashboard.module').then(m => m.DashboardModule) },
        //// { path: 'enterprises', component:EnterpriseComponent },

        { path: 'devices', component:DeviceComponent },
        //{ path: 'devices/:enterpriseId', component:DeviceComponent },

        { path: 'apps/:enterpriseId/:emmDeviceId/:policyId/:deviceId', component: MobileAppComponent},
        //{ path: 'mobile-app-install/:enterpriseId/:deviceId/:policyId', component: MobileAppInstallComponent},
        { path: 'mobile-app-install-managed-google-play/:enterpriseId/:deviceId/:policyId', component: MobileAppInstallManagedGooglePlayComponent},
        
        /*
        { path: 'uikit', loadChildren: () => import\\('./demo/components/uikit/uikit.module').then(m => m.UIkitModule) },
        { path: 'utilities', loadChildren: () => import('./demo/components/utilities/utilities.module').then(m => m.UtilitiesModule) },
        { path: 'documentation', loadChildren: () => import('./demo/components/documentation/documentation.module').then(m => m.DocumentationModule) },
        { path: 'blocks', loadChildren: () => import('./demo/components/primeblocks/primeblocks.module').then(m => m.PrimeBlocksModule) },
        { path: 'pages', loadChildren: () => import('./demo/components/pages/pages.module').then(m => m.PagesModule) }
         */
        {path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ]
  },

  {path: 'sign-in', component: SignInComponent},
  {path: 'sign-up', component: SignUpComponent},
  //{path: 'enterprises', component: EnterpriseComponent},
  //{path: 'admin', component: EnterpriseComponent},
  //{path: 'enterprises/:callbackArguments', component: EnterpriseComponent},
  //{path: 'devices/:enterpriseId', component: DeviceComponent},
  //{path: 'apps/:enterpriseId/:emmDeviceId/:policyId/:deviceId', component: MobileAppComponent},
  //{path: 'mobile-app-install-managed-google-play/:enterpriseId/:deviceId/:policyId', component: MobileAppInstallManagedGooglePlayComponent},
  
  //{path: 'legacy', component: HomeComponent},
  //{path: 'teste/:enterpriseId/:deviceId/:policyId', component: TesteComponent},
  //{path: 'teste', component: TesteComponent},

  {path: '**',   redirectTo: 'home', pathMatch: 'full' },
  //{path: '',     redirectTo: 'sign-in', pathMatch: 'full' },
  ];


@NgModule({
  imports: [
    RouterModule.forRoot(AppRoutingModule.createRoutes()), 
    CommonModule
  ], 
  exports: [RouterModule],
  providers: [DmpCommonsComponent]
})

export class AppRoutingModule{ 
  constructor( 
  public dmpCommons: DmpCommonsComponent
  )
  { 
  }//end constructor 

  public checkPlatformAdmin(): boolean {
    this.dmpCommons.hasRolePlatformAdmin().then((isPlatformAdmin: boolean) => {
      return isPlatformAdmin;
    });
    return true;
  }//end checkIfEnterprisesRouteIsEnabled
  
  // Function to conditionally add enterprise route
  static createRoutes(): Routes {
    const routes = [...baseRoutes];
    
    // Your condition here - could be from environment, localStorage, etc.
    // Note: Static method cannot access instance methods, so defaulting to true for now
    const shouldShowEnterprises = true; // this.checkPlatformAdmin();
    
    if (shouldShowEnterprises) {
      // Add the enterprises route to the home children
      const homeRoute = routes.find(route => route.path === 'home');
      if (homeRoute && homeRoute.children) {
        homeRoute.children.unshift({ path: 'enterprises', component: EnterpriseComponent });
      }
    }
    
    return routes;
  }//end createRoutes

}//end AppRoutingModule


